import * as React from 'react'
import { Box, Typography, useTheme } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { LabelCountry } from "@components"
import { formatDate, formatPercentage, formatPrice } from "@ui-seeker/utils"


export default function retailerColumn() {
	return {
		name: 'competitors', label: 'Competitors',
		options: {
			headerAlign: 'left',
			customBodyRowRenderLite: ([first, second, third]=[], { isRepricing }) => <Box sx={{
				width: 1, height: 1,
				display: 'flex', flexWrap: 'nowrap',
				overflowX: 'auto', overflowY: 'hidden'
			}}>
				<Box sx={{ width: .34, minWidth: 240 }}>
					<RetailerBlock idx={0} { ...first || {} } isRepricing={isRepricing} />
				</Box>
				<Box sx={{ width: .33, minWidth: 240 }}>
					<RetailerBlock idx={1} { ...second || {} } isRepricing={isRepricing} />
				</Box>
				<Box sx={{ width: .33, minWidth: 240 }}>
					<RetailerBlock idx={2} { ...third || {} } isRepricing={isRepricing} />
				</Box>
			</Box>
		}
	}
}

const RetailerBlock = ({idx, country, site, stock, price, currency, oldDiff, newPrice, lastExtraction, isRepricing}) => {
	const { palette } = useTheme()

	if (!country)
		return <></>

	const isFirst = idx === 0
	const isMinorPrice = newPrice === 0
	let colorNewPrice = 'text.primary'
	if (!isMinorPrice)
		colorNewPrice = newPrice > 0 ? 'success.main' : 'error.main'

	return <Box sx={{ width: 1, height: 1, borderLeft: !isFirst && '1px solid', px: !isFirst && 3, borderColor: palette.grey[400] }}>
		<Box sx={{ display: 'flex', alignItems: 'center', fontWeight: 500 }}>
			<LabelCountry country={country} label={site} />
		</Box>
		<Box sx={{ width: 1, my: .5 }}>
			<Typography variant="caption" sx={{ display: 'flex', alignItems: 'center' }} color="text.disabled">
				<Box sx={{ mr: .5 }}>In stock:</Box>
				<Box component="span" sx={{ width: 11, height: 11, borderRadius: '50%', backgroundColor: !stock ? 'error.main' : 'success.main' }} />
			</Typography>
		</Box>
		<Box sx={{width: 1, my: .5}}>
			<Typography variant="caption" sx={{display: 'flex', alignItems: 'center'}} color="text.disabled">
				<Box sx={{ mr: .5, whiteSpace: 'nowrap' }}>
					Diff. Vs Current Price:
				</Box>
				<Typography variant="caption" sx={{ fontWeight: 550 }}>
					{formatPrice(price, currency)}
				</Typography>
				<Box sx={{color: oldDiff >= 0 ? 'success.main' : 'error.main', pl: .5}}>
					{formatPercentage(oldDiff)}
				</Box>
			</Typography>
		</Box>
		{ !!isRepricing && <Box sx={{width: 1, my: .5}}>
			<Typography variant="caption" sx={{display: 'flex', alignItems: 'center'}} color="text.disabled">
				<Box sx={{mr: .5, whiteSpace: 'nowrap'}}>Diff. New Price:</Box>
				<Box sx={{color: colorNewPrice}}>
					{formatPercentage(newPrice)}
				</Box>
			</Typography>
		</Box> }
		<Box sx={{ width: 1, my: .5 }}>
			<Typography variant="caption" sx={{ display: 'flex', alignItems: 'center' }} color="text.disabled">
				<Box sx={{ mr: .5, whiteSpace: 'nowrap' }}>Last Extraction:</Box>
				<Box>
					{formatDate(lastExtraction, { isString: true, format: 'dd/MM/yyyy', receivedFormat: 'yyyy-MM-dd' })}
				</Box>
			</Typography>
		</Box>
	</Box>
}